import React from 'react'
import { X } from 'lucide-react'

const Modal = ({ isOpen, onClose, title, children, size = 'md' }) => {
  if (!isOpen) return null

  const sizeStyles = {
    sm:  { maxWidth: '28rem' },
    md:  { maxWidth: '32rem' },
    lg:  { maxWidth: '42rem' },
    xl:  { maxWidth: '56rem' },
  }

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div
        className="modal"
        style={sizeStyles[size]}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-head">
          <h3 className="font-medium" style={{ fontSize: '1rem' }}>{title}</h3>
          <button className="btn btn-ghost btn-icon" onClick={onClose}>
            <X style={{ width: '1.25rem', height: '1.25rem' }} />
          </button>
        </div>
        <div className="modal-body">
          {children}
        </div>
      </div>
    </div>
  )
}

export default Modal
